export default "__VITE_ASSET__CxCsJcSX__"